export default "__VITE_ASSET__DsVGeCkn__"